(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbDocumentIndexes', DocumentIndexesDirective)
		.controller('smbDocumentIndexesController', [
			'$state',
			'pxProgressService',
			'smbDocumentIndexDataStore',
			'smbDocumentDataStore',
			'smbDocumentDetailsPanelDataStore',
			DocumentIndexesController
		]);

	var templateUrl = require('./documentIndexes.template');
	/**
	 * @ngdoc directive
	 * @name smb-app.smbDocumentIndexes
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * @usage
	 *
	 * <smb-document-indexes />
	 */
	function DocumentIndexesDirective() {
		return {
			restrict: 'E',
			controller: 'smbDocumentIndexesController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				documentId: '@',
				documentTypeId: '@',
				documentGroupId: '@'
			}
		};
	}

	function DocumentIndexesController($state, pxProgressService, smbDocumentIndexDataStore, smbDocumentDataStore, smbDocumentDetailsPanelDataStore) {
		var vm = this;
		vm.loading = false;
		vm.indexDS = smbDocumentIndexDataStore;
		vm.documentDS = smbDocumentDataStore;
		vm.documentDetailsDS = smbDocumentDetailsPanelDataStore;

		(function initDocumentIndexesController() {
			vm.loading = true;
			pxProgressService.visible = true;
			vm.indexDS.getIndexes(vm.documentId, vm.documentTypeId, false)
				.then(function() {
					vm.indexDS.indexValues.sort(function(lhs, rhs) {
						if (lhs.sequence < rhs.sequence) {
							return -1;
						} else if (lhs.sequence === rhs.sequence) {
							return 0;
						} else {
							return 1;
						}
					});
				})
				.then(function() {
					vm.documentDS.loadUserPermissions(vm.documentGroupId);
				})
				.finally(function() {
					vm.loading = false;
					pxProgressService.visible = false;
				});
		}());
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/documentIndexes/documentIndexes.js
// module id = 83
// module chunks = 1